import $ from 'jquery';
import _ from 'underscore';
import Numbered from 'input.numbered';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectTransfer',
			dom: {
				list: '#yotaConnectTransferList',
				footer: '.js-connect-transfer-footer',
				template: '#yotaConnectTransferTemplate',
				phone: '.js-connect-transfer-phone',
				label: '.js-connect-transfer-label',
				input: '.js-connect-transfer-input',
				remove: '.js-connect-transfer-remove',
				add: '.js-connect-transfer-add',
				quantity: '#yotaConnectSimQuantity',
				mnpToggler: '#yotaConnectSimMnp',
				phoneField: '.js-field'
			},
			classes: {
				phone: {
					remove: 'b-connect-transfer__phone_state_remove',
					add: 'b-connect-transfer__phone_state_add',
					error: 'b-connect-transfer__phone_state_error'
				},
				field: {
					error: 'b-field_state_error'
				}
			},
			data: [],
			quantity: 0,
			ids: 'yotaConnectTransferFieldN'
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.fields = [];
		this.quantity = this.options.quantity;
		this.isUpdate = false;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	add() {
		const self = this;
		const html = self.template({
			data: {
				id: self.options.ids + (self.fields.length + 1),
				label: '',
				value: ''
			}
		});

		self.$list.append(html);
		self.getDomFields();
		self.validate(self.fields[self.fields.length - 1], false);
		self.checkCount();
		self.checkQuantity();
	}

	remove(data) {
		const self = this;
		const field = data;
		field.$el.empty().remove();
		self.getDomFields();
		self.validate(self.fields[self.fields.length - 1], false);
		self.checkCount();
		return self;
	}

	checkCount() {
		this.$footer.attr('data-quantity', this.fields.length + ' ' + this.declOfNum(this.fields.length, ['SIM-карта', 'SIM-карты', 'SIM-карт']));
	}

	checkQuantity() {
		const self = this;
		if (self.$mnpToggler.prop('checked') == true) {
			if (Number(self.$quantity.val()) < self.fields.length) {
				self.$quantity.val(self.fields.length);
			}
		}
	}

	validate(data) {
		const self = this;
		const field = data;
		const validate = field.numbered.validate();
		const index = field.$el.index();

		self.$phoneField.removeClass(self.options.classes.field.error);

		self.fields[index].validate = validate > 0;
		self.fields[index].$el.data('validate', self.fields[index].validate);
		self.fields[index].validate = validate > 0;
		let validates = true;
		let server = true;

		const isOnce = self.fields.length == 1;

		$.each(self.fields, function (key, item) {
			if (item.validate === false) {
				validates = false;
			}
			if (item.server === false) {
				server = false;
			}
		});

		if (isOnce) {
			field.$el
				.removeClass(self.options.classes.phone.remove)
				.toggleClass(self.options.classes.phone.add, validates && server)
				.toggleClass(self.options.classes.phone.error, !self.fields[index].server && self.fields[index].label !== '');
		} else {
			$.each(self.fields, function (key, item) {
				const isLast = key + 1 == self.fields.length;
				if (isLast) {
					item.$el
						.toggleClass(self.options.classes.phone.remove, !validates || !server)
						.toggleClass(self.options.classes.phone.add, validates && server)
						.toggleClass(self.options.classes.phone.error, !item.server && item.label !== '');
				} else {
					item.$el
						.removeClass(self.options.classes.phone.add)
						.addClass(self.options.classes.phone.remove)
						.toggleClass(self.options.classes.phone.error, !item.server && item.label !== '');
				}
			});
		}

		if (self.fields[index].validate && self.fields[index].label == '') {
			const list = [];
			$.each(self.fields, function (key, item) {
				if (!item.$input.is(field.$input)) {
					list.push(item.$input.val());
				}
			});

			const transfertDataMapper = transfertData => {
				return {
					phone: transfertData.number || '',
					operator: {
						name: transfertData.orgName || '',
						id: transfertData.ownerId || ''
					},
					region: {
						name: transfertData.regionName || '',
						id: transfertData.regionCode || ''
					},
					error: transfertData.error || false
				};
			};

			$.ajax({
				url: self.$list.attr('action'),
				type: self.$list.attr('method'),
				data: {
					action: 'check',
					phone: field.$input.val(),
					other: list.join('|')
				},
				dataType: 'json',
				success: function (json) {
					json = transfertDataMapper(json);
					if (typeof data[index] == 'undefined') {
						data[index] = json;
					}
					self.fields[index].server = !json.error;

					if (json.error !== false) {
						self.fields[index].label = json.error;
					} else {
						self.fields[index].label = [json.operator.name, json.region.name].join(', ');
					}
					self.fields[index].$label.html(self.fields[index].label);
					self.fields[index].operator = json.operator;
					self.fields[index].region = json.region;
				},
				error: function () {
					self.fields[index].label = 'Невозможно перенести данную SIM-карту';
					self.fields[index].server = false;
					self.fields[index].operator = '';
					self.fields[index].region = '';
					self.fields[index].$label.html(self.fields[index].label);
				},
				complete: function () {
					self.fields[index].$el
						.data('server', self.fields[index].server)
						.data('label', self.fields[index].label)
						.data('operator', self.fields[index].operator)
						.data('region', self.fields[index].region);

					self.validate(field, false);
				}
			});
		}

		if (validate <= 0) {
			self.fields[index].label = '';
			self.fields[index].server = false;
			self.fields[index].$label.html('');
		}
		self.$window.trigger('yota.connect.transfer.resize');
		return self;
	}

	getDomFields() {
		const self = this;
		const fields = [];
		self.$field = self.$el.find(self.options.dom.phone);
		self.$field.each(function () {
			const field = {};
			field.$el = $(this);
			field.$input = field.$el.find(self.options.dom.input);
			field.$label = field.$el.find(self.options.dom.label);
			field.$remove = field.$el.find(self.options.dom.remove);
			field.$add = field.$el.find(self.options.dom.add);
			if (field.$el.data('init') === true) {
				field.numbered = field.$el.data('numbered');
				field.label = field.$el.data('label');
				field.server = field.$el.data('server');
				field.animation = field.$el.data('animation');
				field.validate = field.$el.data('validate');
				field.operator = field.$el.data('operator');
				field.region = field.$el.data('region');
			} else {
				field.$el.data('init', true);
				field.label = '';
				field.server = false;
				field.validate = false;
				field.numbered = new Numbered(field.$input);
				field.$input.on('focus keypress keydown blur change input focusin', self.validate.bind(self, field));
				field.$add.on('click', self.add.bind(self));
				field.$remove.on('click', self.remove.bind(self, field));
				field.animation = new Animation({el: field.$el});
				field.operator = {
					name: '',
					id: ''
				};
				field.region = {
					name: '',
					id: ''
				};
				field.$el
					.data('numbered', field.numbered)
					.data('animation', field.animation)
					.data('validate', field.validate)
					.data('operator', field.validate)
					.data('region', field.region);
			}
			fields.push(field);
		});
		self.fields = fields;
		self.$phoneField = self.$el.find(this.options.dom.phone).find(this.options.dom.phoneField);
	}

	getDom() {
		this.$list = this.$el.find(this.options.dom.list);
		this.$footer = this.$el.find(this.options.dom.footer);
		this.$quantity = $(this.options.dom.quantity);
		this.$template = this.$el.find(this.options.dom.template);
		this.template = _.template(this.$template.html().trim());
		this.$mnpToggler = $(this.options.dom.mnpToggler);

		return this;
	}

	setData(data) {
		const self = this;
		self.getDomFields();

		if (self.fields.length > data.length && self.fields.length > 1) {
			while (self.fields.length > data.length && self.fields.length > 1) {
				self.remove(self.fields[self.fields.length - 1]);
			}
		}
		if (self.fields.length < data.length) {
			while (self.fields.length < data.length) {
				self.add();
			}
		}
		$.each(self.fields, function (index, field) {
			if (typeof data[index] != 'undefined') {
				const json = data[index];
				self.fields[index].server = !json.error;

				if (json.error !== false) {
					self.fields[index].label = json.error;
				} else {
					self.fields[index].label = [json.operator.name, json.region.name].join(', ');
				}

				field.numbered.setVal(json.phone);
				self.fields[index].$label.html(self.fields[index].label);
				self.fields[index].operator = json.operator;
				self.fields[index].region = json.region;

				self.fields[index].$el
					.data('server', self.fields[index].server)
					.data('label', self.fields[index].label)
					.data('operator', self.fields[index].operator)
					.data('region', self.fields[index].region);

				self.validate(self.fields[index], false);
			}
		});
		return self;
	}

	update(data) {
		if (typeof data !== 'undefined') {
			this.data = data;
		}
		this.setData(this.data);
		this.checkCount();
		return this;
	}

	declOfNum(number, titles) {
		const cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	onQuantity(event, quantity) {
		const self = this;
		self.quantity = quantity;
		self.checkCount();
		return self;
	}

	onCheck() {
		const self = this;
		if (self.isUpdate !== true) {
			$.ajax({
				url: self.$list.attr('action'),
				type: self.$list.attr('method'),
				data: self.$list.serialize(),
				dataType: 'json',
				success: function (json) {
					if (json) {
						self.update(json);
					}
				}
			});
		}
		return self;
	}

	get() {
		const self = this;
		let json = [];
		let error = false;
		let result = false;
		const isMnp = self.$mnpToggler.prop('checked') == true;
		$.each(self.fields, function (key, field) {
			if (field.$input.val().indexOf('_') != -1) {
				error = true;
				const $phoneBlock = field.$input.closest('.js-field');
				$phoneBlock.addClass(self.options.classes.field.error);
			} else {
				json.push({
					phone: field.$input.val(),
					operator: field.operator,
					region: field.region
				});
			}
		});

		if (!isMnp) {
			error = false;
			json = [];
			json.push({
				phone: '',
				operator: {
					name: '',
					id: ''
				},
				region: {
					name: '',
					id: ''
				}
			});
			result = JSON.stringify(json);
		}

		if (error) {
			result = false;
		} else {
			result = JSON.stringify(json);
		}

		return result;
	}

	onSubmit(event) {
		event.preventDefault();
	}

	render() {
		if (this.$el.length) {
			this
				.getDom()
				.update();

			this.$window.on('yota.connect.transfer.quantity', this.onQuantity.bind(this));
			this.$window.on('yota.connect.transfer.check', this.onCheck.bind(this));

			this.$quantity.on('blur focus', this.checkQuantity.bind(this));

			if (this.fields.length === 0) {
				this.add();
			}

		}
		return this;
	}
}




// WEBPACK FOOTER //
// ./app/portlets/site/connect/transfer/transfer.js